<template>
  <div class="animated fadeIn">
    <b-modal
      title="Deleting sale"
      class="modal-primary"
      v-model="modalDelete"
      @ok="deleteData(), (modalDelete = false)"
    >
      Are you sure you want to delete selected item?
    </b-modal>
    <b-modal
      title="Edit"
      class="modal-primary"
      v-model="modalEdit"
      @ok="updateData(), (modalEdit = false)"
    >
      <b-row>
        <b-col lg="6">
          <b-form-input
            v-model="companyEdit"
            placeholder="Company"
            style="height:45px;"
            class="mb-2"
          ></b-form-input>
        </b-col>
        <b-col lg="6">
          <b-form-input
            v-model="contactEdit"
            placeholder="Contact Name"
            style="height:45px;"
            class="mb-2"
          ></b-form-input>
        </b-col>
        <b-col lg="6">
          <b-form-input
            v-model="phoneEdit"
            placeholder="Phone Number"
            style="height:45px;"
            class="mb-2"
          ></b-form-input>
        </b-col>
        <b-col lg="6">
          <b-form-input
            v-model="addressEdit"
            placeholder="Address"
            style="height:45px;"
            class="mb-2"
          ></b-form-input>
        </b-col>
        <b-col lg="6">
          <b-form-input
            v-model="locationEdit"
            placeholder="City"
            style="height:45px;"
            class="mb-2"
          ></b-form-input>
        </b-col>
        <b-col lg="3">
          <b-form-input
            v-model="stateEdit"
            placeholder="State"
            style="height:45px;"
            class="mb-2"
          ></b-form-input>
        </b-col>
        <b-col lg="3">
          <b-form-input
            v-model="zipEdit"
            placeholder="Zip"
            style="height:45px;"
            class="mb-2"
          ></b-form-input>
        </b-col>
        <b-col lg="12">
          <b-form-select
            v-model="statusEdit"
            :options="statusOptions"
            style="height:45px;"
            class="mb-2 selectlocation"
            value-field="value"
            text-field="text"
          >
          </b-form-select>
        </b-col>
        <b-col lg="12">
          <b-form-textarea
            id="textarea"
            v-model="commentEdit"
            placeholder="Comment"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-col>
      </b-row>
    </b-modal>
    <b-row>
      <b-col lg="12">
        <b-card class="information" header="data">
          <div slot="header">
            <h5
              style="display: inline;"
              class="card-title mb-0"
              ref="header_title"
              @click="scrollToBottom()"
            >
              Add New
            </h5>
          </div>
          <div>
            <b-row>
              <b-col lg="4">
                <b-form-input
                  v-model="company"
                  placeholder="Company"
                  style="height:45px;"
                  class="mb-2"
                ></b-form-input>
              </b-col>
              <b-col lg="4">
                <b-form-input
                  v-model="contact"
                  placeholder="Contact Name"
                  style="height:45px;"
                  class="mb-2"
                ></b-form-input>
              </b-col>
              <b-col lg="4">
                <b-form-input
                  v-model="phone"
                  placeholder="Phone Number"
                  style="height:45px;"
                  class="mb-2"
                ></b-form-input>
              </b-col>
              <b-col lg="4">
                <b-form-input
                  v-model="address"
                  placeholder="Address"
                  style="height:45px;"
                  class="mb-2"
                ></b-form-input>
              </b-col>
              <b-col lg="4">
                <b-form-input
                  v-model="location"
                  placeholder="City"
                  style="height:45px;"
                  class="mb-2"
                ></b-form-input>
              </b-col>
              <b-col lg="2">
                <b-form-input
                  v-model="state"
                  placeholder="State"
                  style="height:45px;"
                  class="mb-2"
                ></b-form-input>
              </b-col>
              <b-col lg="2">
                <b-form-input
                  v-model="zip"
                  placeholder="Zip"
                  style="height:45px;"
                  class="mb-2"
                ></b-form-input>
              </b-col>
              <b-col lg="12">
                <b-form-select
                  v-model="status"
                  :options="statusOptions"
                  style="height:45px;"
                  class="mb-2 selectlocation"
                  value-field="value"
                  text-field="text"
                >
                </b-form-select>
              </b-col>
              <b-col lg="12">
                <b-form-textarea
                  id="textarea"
                  v-model="comment"
                  placeholder="Comment"
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </b-col>
              <b-col lg="12">
                <b-button
                  variant="outline-primary"
                  @click="sendData"
                  style="display:block; margin:auto;  margin-top:30px; height:40px; width:130px"
                  >Submit</b-button
                >
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>

      <b-col lg="12">
        <b-card class="information" header="data">
          <div slot="header">
            <b-row>
              <b-col lg="8">
                <h5 style="display: inline;" class="card-title mb-0">
                  Sales Rep
                </h5>
              </b-col>
              <b-col lg="4">
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"
                      >Clear</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
          </div>
          <div>
            <b-table
              :filter="filter"
              :fields="fields"
              size="lg"
              :items="items"
              :tbody-tr-class="rowClass"
            >
            <template v-slot:cell(date)="data">{{ data.item.date.slice(0,-3) }}</template>
              <template v-slot:cell(actions)="data">
                <div class="actions-container">
                <b-button
                  variant="primary"
                  @click="() => $router.push('/viewSale/?id=' + data.item.id)"
                  >Open
                </b-button>
                <b-button
                  variant="outline-primary"
                  @click="openDelete(data.item)"
                  :ref="'element' + data.item.id"
                  ><i
                    class="fa fa-trash"
                    :style="saleId === data.item.id ? '' : 'color: white;'"
                    aria-hidden="true"
                  ></i
                ></b-button>
              </div>
              </template>
            </b-table>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import router from "../../router";
import { allowedPath } from "../../shared/utils";

export default {
  name: "model",
  components: {},
  data: function() {
    return {
      loadingData: true,
      filter: null,
      modalEdit: false,
      modalDelete: false,
      saleId: "",
      timer: false,
      id: "",
      companyEdit: "",
      locationEdit: "",
      addressEdit: "",
      contactEdit: "",
      stateEdit: "",
      phoneEdit: "",
      zipEdit: "",
      commentEdit: "",
      company: "",
      location: "",
      address: "",
      contact: "",
      state: "",
      phone: "",
      zip: "",
      comment: "",
      items: [],
      status: "Inactive existing customer",
      statusEdit: "",
      statusOptions: [
        {
          value: "Inactive existing customer",
          text: "Inactive existing customer"
        },
        {
          value: "Active Target",
          text: "Active Target"
        },
        {
          value: "Closed/Lost",
          text: "Closed/Lost"
        },
        {
          value: "Closed/Won",
          text: "Closed/Won"
        }
      ],
      fields: [
        { key: "date", label: "Date" },
        { key: "company", label: "Company" },
        { key: "contact", label: "Contact Name" },
        { key: "name", label: "Created By" },
        { key: "phone_no", label: "Phone Number" },
        { key: "city", label: "City" },
        { key: "address", label: "Address" },
        { key: "zip", label: "Zip" },
        { key: "status", label: "Status" },
        { key: "comment", label: "Comment" },
        { key: "actions", label: "Actions" }
      ]
    };
  },
  methods: {
    openEdit(data) {
      this.id = data.id;
      this.companyEdit = data.company;
      this.locationEdit = data.city;
      this.addressEdit = data.address;
      this.contactEdit = data.contact;
      this.stateEdit = data.state;
      this.phoneEdit = data.phone_no;
      this.zipEdit = data.zip;
      this.commentEdit = data.comment;
      this.statusEdit = data.status;
      this.modalEdit = true;
    },
    openDelete(data) {
      this.id = data.id;
      this.modalDelete = true;
    },
    deleteData() {
      let formData = new FormData();
      formData.append("id", this.id);

      this.$http
        .post("api/fns/sales/deleteSale.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(
          () => {
            this.fetchData();
          },
          err => {
            console.log(err);
          }
        );
    },
    updateData() {
      let formData = new FormData();

      formData.append("id", this.id);

      formData.append("company", this.companyEdit);
      formData.append("contact", this.contactEdit);
      formData.append("phone", this.phoneEdit);

      formData.append("address", this.addressEdit);
      formData.append("location", this.locationEdit);
      formData.append("state", this.stateEdit);
      formData.append("zip", this.zipEdit);
      formData.append("status", this.statusEdit);

      formData.append("comment", this.commentEdit);
      if (this.companyEdit === "") {
        alert("Please, fill in the company name");
        return;
      }

      this.$http
        .post("api/fns/sales/editSale.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(
          () => {
            this.fetchData();
          },
          err => {
            console.log(err);
          }
        );
    },
    sendData() {
      let formData = new FormData();
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;

      formData.append("date", dateTime);

      formData.append("company", this.company);
      formData.append("contact", this.contact);
      formData.append("phone", this.phone);

      formData.append("address", this.address);
      formData.append("location", this.location);
      formData.append("state", this.state);
      formData.append("zip", this.zip);
      formData.append("status", this.status);

      formData.append("comment", this.comment);
      formData.append("user", localStorage.getItem("fns_full_name"));

      if (this.company === "") {
        alert("Please, fill in the company name");
        return;
      }

      this.$http
        .post("api/fns/sales/addSale.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(
          () => {
            this.company = "";
            this.contact = "";
            this.phone = "";
            this.address = "";
            this.location = "";
            this.zip = "";
            this.comment = "";
            this.state = "";

            this.fetchData();
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        user: localStorage.getItem("fns_full_name")
      };
      this.$http
        .get("api/fns/sales/SalesPreview.php", {
          params
        })
        .then(
          res => {
            this.items = res.data;
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.id == this.saleId) {
        return "table-info highlighted-row";
      }
    },
    scrollToBottom() {
      if (this.saleId)
        this.$refs["element" + this.saleId].scrollIntoView({
          behavior: "smooth"
        });
    }
  },
  mounted() {
    allowedPath(
      router.currentRoute.path,
      localStorage.getItem("user_tabs"),
      localStorage.getItem("redirect_path")
    );
    this.fetchData();
    if (this.$route.query.hasOwnProperty("saleId")) {
      this.saleId = this.$route.query.saleId;
      this.timer = setTimeout(() => {
        this.$refs.header_title.click();
      }, 1000);
    }
  },
  beforeUnmount() {
    clearTimeout(this.timer);
    this.saleId = "";
  }
};
</script>

<style>
.title-details {
  padding: 0.5em;
  padding-bottom: 0.2em !important;
  font-size: 1.1em;
  display: block;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
.selectlocation {
  background: #515b65;
  border: 1px solid black;
  color: white;
}
.highlighted-row {
  color: black;
}
.actions-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.actions-container button:first-child{
  margin-bottom:10%;
}
</style>
